import React, {Component} from 'react';
import Head from '../Head/Head';
import {Link} from 'react-router';

export default class Error_404_not_found extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        const error = (this.props.location && this.props.location.query && this.props.location.query.error) ? this.props.location.query.error : "Hubo un error"
        const texto = (this.props.location && this.props.location.query && this.props.location.query.texto) ? this.props.location.query.texto : "Si lo neceista pongase en contacto con nostros. por favor."
        return (
            <div className="Homepage-banner">
                <Head
                    previousPath={"registro"}
                />
                <div className="page-login main-content">
                    <div className="container">
                        <div className="container-thanks">
                            <div className="container-text">
                                <h4>{error}</h4>
                                <h6>{texto}</h6>
                            </div>

                            <div className="back-button">
                                <Link to="/contacta-con-nosotros" className="btn btn-outline-secondary btn-get-started">Hablar
                                    con soporte a cliente</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        $('.index-resume__heading').show();
        //$('.header-topbar').css("visibility", "visible");
    }
}